import React, { useState } from 'react';
import {
  RETAIL_INPUTS,
  RETAIL_INPUTS_VARIANTS
} from '../../../_shared/constants/retail';

import { StyledInput } from './Styles';

const Input = React.forwardRef((props, ref) => {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const priceRegex = /^[0-9\b]+$/;
  const {
    inputId,
    placeholder,
    type,
    maxLength,
    width,
    pattern,
    defaultValue
  } = props;

  const [variant, setVariant] = useState(RETAIL_INPUTS_VARIANTS.INFO);

  const onCustomizationChange = e => {
    const { value, id } = e.currentTarget;
    const strValue = value.replace(/[^\w\s]/gi, '');

    if (!value || value.length === 0) {
      setVariant(RETAIL_INPUTS_VARIANTS.INFO);
      return;
    }

    switch (id) {
      case RETAIL_INPUTS.PHONE:
        {
          // Special masking for phone number input
          if (strValue && strValue.length !== 10) {
            setVariant(RETAIL_INPUTS_VARIANTS.ERROR);
            return;
          }
          const first3 = strValue.substring(0, 3);
          const mid3 = strValue.substring(3, 6);
          const last4 = strValue.substring(6, 10);

          e.currentTarget.value = `${first3}${mid3 ? '-' : ''}${mid3}${
            last4 ? '-' : ''
          }${last4}`;
          setVariant(RETAIL_INPUTS_VARIANTS.INFO);
        }
        break;
      case RETAIL_INPUTS.NAME:
        break;
      case RETAIL_INPUTS.EMAIL:
        if (emailRegex.test(value)) {
          setVariant(RETAIL_INPUTS_VARIANTS.INFO);
        } else {
          setVariant(RETAIL_INPUTS_VARIANTS.ERROR);
        }
        break;
      case RETAIL_INPUTS.PRICE:
        if (priceRegex.test(value)) {
          setVariant(RETAIL_INPUTS_VARIANTS.INFO);
        } else {
          setVariant(RETAIL_INPUTS_VARIANTS.ERROR);
        }
        break;
      default:
        break;
    }
  };

  const handleKeyDown = e => {
    // For the Price input field
    // Checks if the key pressed was a number key and unblocks other important keys
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'End',
      'Home',
      'PageDown',
      'PageUp'
    ];

    if (
      e?.currentTarget?.id === RETAIL_INPUTS.PRICE &&
      !/\d/.test(e?.key) &&
      !(
        e?.getModifierState() ||
        allowedKeys.includes(e?.key) ||
        (e?.key === 'a' && (e?.ctrlKey || e?.metaKey)) ||
        e?.key.includes('Arrow')
      )
    ) {
      e.preventDefault();
      return false;
    }
    return true;
  };

  return (
    <StyledInput
      id={inputId}
      placeholder={placeholder}
      type={type}
      maxLength={maxLength}
      width={width}
      variant={
        variant === RETAIL_INPUTS_VARIANTS.ERROR && RETAIL_INPUTS_VARIANTS.ERROR
      }
      onChange={onCustomizationChange}
      data-testid={`retailCust-dealer-${inputId}`}
      pattern={pattern}
      ref={ref}
      inputMode={type === 'number' ? 'numeric' : type}
      onKeyDown={handleKeyDown}
      defaultValue={defaultValue}
    />
  );
});

export default Input;
